<template>
    <tr v-if="metricsData && metricsData.models && displayColumns && blockedColumns" class="bg-gray-800/70 border-t-2 border-b-2 border-white">
        <td class="z-9 bg-gray-800">Average</td>
        <td v-if="!selectedModel">{{addSpace(metricsData.models.toFixed(2))}}</td>
        <td></td>
        <slot v-if="displayColumns.free">
            <td :class="{'text-green-400':metricsData.free.fans_expired<0,'text-red-400':metricsData.free.fans_expired>0}">{{addSpace(metricsData.free.fans_expired.toFixed(2))}}</td>
            <td :class="{'text-green-400':metricsData.free.new>0,'text-red-400':metricsData.free.new<0}">{{addSpace(metricsData.free.new.toFixed(2))}}</td>
        </slot>
        <td :class="{'text-green-400':metricsData.free.change>0,'text-red-400':metricsData.free.change<0}">{{addSpace(metricsData.free.change.toFixed(2))}}</td>
        <td></td>
        <slot v-if="displayColumns.paid">
            <td :class="{'text-green-400':metricsData.paid.fans_expired<0,'text-red-400':metricsData.paid.fans_expired>0}">{{addSpace(metricsData.paid.fans_expired.toFixed(2))}}</td>
            <td :class="{'text-green-400':metricsData.paid.fans_expired>0,'text-red-400':metricsData.paid.fans_expired<0}">{{addSpace(metricsData.paid.new.toFixed(2))}}</td>
        </slot>
        <td :class="{'text-green-400':metricsData.paid.change>0,'text-red-400':metricsData.paid.change<0}">{{addSpace(metricsData.paid.change.toFixed(2))}}</td>
        <td v-if="blockedColumns.renewOn == 1 && displayRenewOn">{{metricsData.paid.renewOn.toFixed(2)}}</td>
        <td>{{metricsData.free.messages.toFixed(2)}}</td>
        <td>{{metricsData.paid.messages.toFixed(2)}}</td>
        <td v-if="blockedColumns.subsPaid == 1 && displaySubs">$ {{addSpace(metricsData.paid.subsEarnings.toFixed(2))}}</td>
        <td>$ {{addSpace(metricsData.free.transactionSum.toFixed(2))}}</td>
        <td>$ {{addSpace(metricsData.paid.transactionSum.toFixed(2))}}</td>
        <td>$ {{addSpace((metricsData.free.transactionSum + metricsData.paid.transactionSum).toFixed(2))}}</td>
        <slot v-if="!selectedModel">
            <td :class="{'text-green-400':metricsData.free.change>0,'text-red-400':metricsData.free.change<0}">{{addSpace((metricsData.free.change/metricsData.models).toFixed(2))}}</td>
            <td>$ {{addSpace(((metricsData.free.transactionSum + metricsData.paid.transactionSum)/metricsData.models).toFixed(2))}}</td>
        </slot>
    </tr>
</template>

<script>
    export default {
        props: ['displayRenewOn','displaySubs','blockedColumns','selectedModel','metricsData','displayColumns'],
        methods: {
            addSpace(nStr) {
                nStr += '';
                var x = nStr.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? '.' + x[1] : '';
                var rgx = /(\d+)(\d{3})/;
                while (rgx.test(x1)) {
                    x1 = x1.replace(rgx, '$1' + " " + '$2');
                }
                return x1 + x2;
            },
        }
    }
</script>

<style scoped>
    @import "@/assets/css/metrics.css"
</style>